var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(
      _vm.$route.path !== '/login' &&
      _vm.$route.path !== '/register-customer' &&
      !_vm.$route.path.includes('register') &&
      _vm.$route.path !== '/register-success' &&
      _vm.$route.path !== '/questionnaire' &&
      _vm.$route.name !== 'checkout' &&
      _vm.$route.path !== '/registrar-mis-clientes'
    )?_c('NavBar'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }